import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  DataEntityVolumeApiResponse,
  DataEntityVolumeSaveRequest,
  DataEntityVolumeSaveResponse
} from 'src/app/Interface/DataEntity/DataEntityVolumeForm_Interface';
import { environment } from 'src/environments/environment';

export const DATA_ENTITY_VOLUME_FORM_POST_ENDPOINT = 'api/Volume/SamplerCertificate';

export const DATA_ENTITY_VOLUME_FORM_GET_ENDPOINT = 'api/Volume/SamplerCertificate';

@Injectable({
  providedIn: 'root'
})
export class DataEntityVolumeFormService {
  private readonly fileBaseUrl = environment.LabUrl;

  constructor(private http: HttpClient) {}

  getById(id: number): Observable<DataEntityVolumeApiResponse> {
    return this.http.get<DataEntityVolumeApiResponse>(
      `${environment.LabUrl}${DATA_ENTITY_VOLUME_FORM_GET_ENDPOINT}?CalibrationDetailId=${id}`
    );
  }

  save(request: DataEntityVolumeSaveRequest): Observable<DataEntityVolumeSaveResponse> {
    return this.http.post<DataEntityVolumeSaveResponse>(
      environment.LabUrl + DATA_ENTITY_VOLUME_FORM_POST_ENDPOINT,
      request
    );
  }

  downloadCertificateFile(certificatePath: string): Observable<Blob> {
    return this.http.get(this.buildCertificateFileUrl(certificatePath), {
      responseType: 'blob'
    });
  }

  private buildCertificateFileUrl(certificatePath: string): string {
    const normalizedPath = this.normalizeCertificateFilePath(certificatePath);
    if (!normalizedPath) {
      throw new Error('Invalid certificate file path');
    }

    if (/^https?:\/\//i.test(normalizedPath)) {
      return normalizedPath;
    }

    const baseUrl = this.fileBaseUrl.replace(/\/+$/, '');
    const relativePath = normalizedPath.replace(/^\/+/, '');
    return `${baseUrl}/${relativePath}`;
  }

  private normalizeCertificateFilePath(value: string): string | null {
    if (typeof value !== 'string') {
      return null;
    }

    const normalized = value.trim();
    return normalized.length > 0 ? normalized : null;
  }
}
